import GameState from "slotworks/model/game-state";
import Record from "slotworks/model/gameplay/records/record";
import { ExpansionResult } from "slotworks/model/gameplay/records/results/expansion-result";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";

export default class HasExpansion extends Decision {
    public evaluate() {

        let hasExpansion = false;

        const record: Record = GameState.getCurrentGame().getCurrentRecord();

        if (record instanceof SpinRecord) {
            const expansions: ExpansionResult[] = record.getResultsOfType(ExpansionResult);
            if (expansions.length) {
                hasExpansion = true;
            }
        }

        return hasExpansion ? Exit.True : Exit.False;
    }
}
